import { type DatasetName } from '@autone/redux/data-ingestion';

import {
  BoxIcon,
  CalculatorIcon,
  ForecastIcon,
  ProductionIcon,
  SalesIcon,
  WarehouseIcon,
} from '../../../../icons';
import { type AutoneIconComponent } from '../../../../icons/factory/create-icon-component';

export const datasetIconMap: Record<DatasetName, AutoneIconComponent> = {
  sales: SalesIcon,
  inventory: BoxIcon,
  warehouse: WarehouseIcon,
  production: ProductionIcon,
  forecast: ForecastIcon,
  solver_run: CalculatorIcon,
};
